import React from 'react';
import Icon from '../../../../generic-components/Icon';
import { colorPicked, whiteColorPicked } from '../../../../assets/svg';
import { IColor } from './ColorList';

interface IProps {
  selectedItems: string[];
  item: IColor;
  handleItemSelection: () => void;
}
const ColorItem = ({ selectedItems, item, handleItemSelection }:IProps) => (
  <div
    key={`color-${item.name}`}
    role='button'
    tabIndex={0}
    onKeyDown={() => {}}
    id={item.name}
    onClick={handleItemSelection}
    className='w-[98px] h-[78px] flex flex-col items-center justify-center rounded-[4px] cursor-pointer'
    data-isselected={selectedItems.includes(item.color) ? 'true' : null}
  >
    {selectedItems.includes(item.color) ? (
      <div className='w-[46px] h-[46px] border border-bw07 flex items-center justify-center rounded-full mb-[4px]'>
        <div
          style={{ backgroundColor: `${item.color}` }}
          className={`w-[38px] h-[38px] flex items-center justify-center rounded-full ${item.name === 'White' ? 'border border-bw03' : ''}`}
        >
          <Icon className='w-[20px] h-[20px]' src={item.name === 'White' ? whiteColorPicked : colorPicked} />
        </div>
      </div>
    ) : (
      <div className='w-[46px] h-[46px] flex items-center justify-center rounded-full mb-[4px] hover:border hover:border-bw04'>
        <div
          style={{ backgroundColor: `${item.color}` }}
          className={`w-[38px] h-[38px] flex items-center justify-center rounded-full ${item.name === 'White' ? 'border border-bw03' : ''}`}
        />
      </div>
    )}
    <span className='text-bw07 font-metric text-base'>{item.name}</span>
  </div>
);

export default ColorItem;
